import { render, staticRenderFns } from "./SalesProducts.vue?vue&type=template&id=65945cf4"
import script from "./SalesProducts.vue?vue&type=script&lang=js"
export * from "./SalesProducts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports